export class MessagingStatLog {
    id: number;
    messageId: string;
    messageType: number;
    errorMessage: string;
    errorPresent: boolean;
    reportNumber: number;
    errorResolved: boolean;
    timestamp: Date;
    resolvingUser: number;
    timeResolved: Date;
    screeningId: number;
    resolvingUserName: string;
    resolutionNote: string;
    public messageTypePretty: string;
    clientName: string;
    locationName: string;
    sendTo: string;
    emailSentTo : string;
}


//this is causing all kinda grief for pretty display.. gonna just use a switch, but i want to keep this here in case we need it later
export enum MessagingType {
    AAL = 1,
    ConsumerDisclosure = 2,
    MasterSheet = 3,
    Invoice = 4,
    IDVerNoPhone = 5
}

export class MessagingFilter {
    reportNumber: number;
    clientName: string;
    locationName: string;
}